// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vx2y","left":"styles_left__2tpoq","desktopActions":"styles_desktopActions__1_zGf","title":"styles_title__1K-fA"};